<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('PositionTool', function() {
            return {
                group: 'Position', category: 'Position', icon: 'long_position.svg',
                name: 'Long Position',
                type: 'Position',
                hint: 'Long Position',
                data: [],
                settings: { mode: 'long', rrRatio: 3 },
                mods: {
                    'Short': {
                        settings: { mode: 'short', rrRatio: 3 },
                        category: 'Position',
                        icon: 'short_position.svg',
                        hint: 'Short Position',
                        name: 'Short Position'
                    }
                }
            }
        }, s => s.mode === 'short' ? 'Short Position' : 'Long Position')
</script>
